module.exports = __webpack_public_path__ + "static/media/logo.6b0a7441.png";